import { withProfiler } from "@sentry/react";
import { StrictMode } from "react";

import { cookieExtractor } from "@shared/helpers";
import type { Flipper } from "@shared/types/flipper";
import type { PractitionerType } from "@unauthenticated/shared/data/types";
import { ErrorBoundary, Providers } from "@unauthenticated/signupSignin/components";

import { Pages } from "./Pages";

interface Props {
  currentCountry: string;
  practitionerTypes: PractitionerType[];
  emailRegex: string;
  signUpAdditionalAttributes?: any;
  signInAdditionalAttributes?: any;
  csuid: string;
  flippers: Flipper[];
  ssoErrors?: string;
  authErrors?: string;
  isFromWellevate?: boolean;
  isFromEmersonEcologics?: boolean;
  isEmerson?: boolean;
  e2e: boolean;
  analyticsAnonymousId: string;
}

const AuthLandingPage = ({
  currentCountry,
  practitionerTypes,
  emailRegex,
  signUpAdditionalAttributes,
  signInAdditionalAttributes,
  csuid,
  flippers,
  ssoErrors,
  authErrors,
  isFromWellevate,
  isFromEmersonEcologics,
  isEmerson,
  e2e,
  analyticsAnonymousId,
}: Props) => {
  const pageVersion = "prac_by_default_with_sso";

  const { _gid: googleId, _ga: googleAnalyticsId } = cookieExtractor(["_gid", "_ga"]);

  const optionalAttributesForSignUp = {
    ...signUpAdditionalAttributes,
    googleId,
    googleAnalyticsId,
  };

  return (
    <StrictMode>
      <Providers
        {...{
          emailRegex,
          currentCountry,
          flippers,
          isFromWellevate,
          isFromEmersonEcologics,
          isEmerson,
          e2e,
          analyticsAnonymousId,
        }}
      >
        <ErrorBoundary {...{ csuid, flippers, pageVersion }}>
          <Pages
            practitionerTypes={practitionerTypes}
            signUpAdditionalAttributes={optionalAttributesForSignUp}
            signInAdditionalAttributes={signInAdditionalAttributes}
            csuid={csuid}
            ssoErrors={ssoErrors}
            authErrors={authErrors}
            pageVersion={pageVersion}
          />
        </ErrorBoundary>
      </Providers>
    </StrictMode>
  );
};

const AuthLandingPageWithProfiler = withProfiler(AuthLandingPage);
export { AuthLandingPageWithProfiler as AuthLandingPage };
